/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1MoverMatchCount } from '../models/V1MoverMatchCount';
import { HttpFile } from '../http/http';

export class V1GetNewMoverMatchCountResponse {
    /**
    * The number of matched households found in the requested state or zipcodes per mover type.
    */
    'moverMatchCounts'?: Array<V1MoverMatchCount>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "moverMatchCounts",
            "baseName": "mover_match_counts",
            "type": "Array<V1MoverMatchCount>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1GetNewMoverMatchCountResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

